/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ teamAgeGroup: NonNullable<unknown>, teamGender: NonNullable<unknown>, divisionAgeGroup: NonNullable<unknown>, divisionGender: NonNullable<unknown> }} Err_Division_MismatchInputs */

const th_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ทีมนี้เป็นรุ่น ${i?.teamAgeGroup} ${i?.teamGender} แต่ดิวิชั่นนั้นเป็น ${i?.divisionAgeGroup} ${i?.divisionGender}`)
};

const en_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This team is ${i?.teamAgeGroup} ${i?.teamGender}; that division is ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const ja_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`このチームは${i?.teamAgeGroup} ${i?.teamGender}ですが、そのディビジョンは${i?.divisionAgeGroup} ${i?.divisionGender}です。`)
};

const zh_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`这支球队属于 ${i?.teamAgeGroup} ${i?.teamGender}；此分区是 ${i?.divisionAgeGroup} ${i?.divisionGender}。`)
};

const es_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este equipo es ${i?.teamAgeGroup} ${i?.teamGender}; esa categoría es ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const pt_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este time é ${i?.teamAgeGroup} ${i?.teamGender}; essa categoria é ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const id_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tim ini ${i?.teamAgeGroup} ${i?.teamGender}; divisi ini ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const fr_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cette équipe est ${i?.teamAgeGroup} ${i?.teamGender} ; cette catégorie est ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const tl_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.teamAgeGroup} ${i?.teamGender} ang team na ito; ${i?.divisionAgeGroup} ${i?.divisionGender} ang dibisyong ito.`)
};

const vi_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đội này là ${i?.teamAgeGroup} ${i?.teamGender}; bảng này là ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const ko_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`이 팀은 ${i?.teamAgeGroup} ${i?.teamGender}이고, 이 디비전은 ${i?.divisionAgeGroup} ${i?.divisionGender}입니다.`)
};

const de_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Team ist ${i?.teamAgeGroup} ${i?.teamGender}; diese Klasse ist ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const ru_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Эта команда — ${i?.teamAgeGroup} ${i?.teamGender}; этот дивизион — ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const tr_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bu takım ${i?.teamAgeGroup} ${i?.teamGender}; bu grup ise ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const it_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questa squadra è ${i?.teamAgeGroup} ${i?.teamGender}; questa categoria è ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const pl_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ta drużyna to ${i?.teamAgeGroup} ${i?.teamGender}; ta grupa to ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const uk_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ця команда — ${i?.teamAgeGroup} ${i?.teamGender}; цей дивізіон — ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const hi_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`यह टीम ${i?.teamAgeGroup} ${i?.teamGender} है; यह वर्ग ${i?.divisionAgeGroup} ${i?.divisionGender} है।`)
};

const ar_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`هذا الفريق ${i?.teamAgeGroup} ${i?.teamGender}؛ وهذه الفئة ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const ms_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pasukan ini ${i?.teamAgeGroup} ${i?.teamGender}; divisyen ini ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const bn_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`এই দল ${i?.teamAgeGroup} ${i?.teamGender}; এই বিভাগ ${i?.divisionAgeGroup} ${i?.divisionGender}।`)
};

const zh_tw2_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`這支球隊是 ${i?.teamAgeGroup} ${i?.teamGender}；這個分組是 ${i?.divisionAgeGroup} ${i?.divisionGender}。`)
};

const zh_hk2_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`這支球隊是 ${i?.teamAgeGroup} ${i?.teamGender}；這個組別是 ${i?.divisionAgeGroup} ${i?.divisionGender}。`)
};

const ur_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`یہ ٹیم ${i?.teamAgeGroup} ${i?.teamGender} ہے؛ یہ درجہ ${i?.divisionAgeGroup} ${i?.divisionGender} ہے۔`)
};

const fa_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`این تیم ${i?.teamAgeGroup} ${i?.teamGender} است؛ این گروه ${i?.divisionAgeGroup} ${i?.divisionGender} است.`)
};

const sw_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timu hii ni ${i?.teamAgeGroup} ${i?.teamGender}; daraja hili ni ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

const nl_err_division_mismatch = /** @type {(inputs: Err_Division_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dit team is ${i?.teamAgeGroup} ${i?.teamGender}; deze klasse is ${i?.divisionAgeGroup} ${i?.divisionGender}.`)
};

/**
* | output |
* | --- |
* | "This team is {teamAgeGroup} {teamGender}; that division is {divisionAgeGroup} {divisionGender}." |
*
* @param {Err_Division_MismatchInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_division_mismatch = /** @type {((inputs: Err_Division_MismatchInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Division_MismatchInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_division_mismatch(inputs)
	if (locale === "ja") return ja_err_division_mismatch(inputs)
	if (locale === "zh") return zh_err_division_mismatch(inputs)
	if (locale === "es") return es_err_division_mismatch(inputs)
	if (locale === "pt") return pt_err_division_mismatch(inputs)
	if (locale === "id") return id_err_division_mismatch(inputs)
	if (locale === "fr") return fr_err_division_mismatch(inputs)
	if (locale === "tl") return tl_err_division_mismatch(inputs)
	if (locale === "vi") return vi_err_division_mismatch(inputs)
	if (locale === "ko") return ko_err_division_mismatch(inputs)
	if (locale === "de") return de_err_division_mismatch(inputs)
	if (locale === "ru") return ru_err_division_mismatch(inputs)
	if (locale === "tr") return tr_err_division_mismatch(inputs)
	if (locale === "it") return it_err_division_mismatch(inputs)
	if (locale === "pl") return pl_err_division_mismatch(inputs)
	if (locale === "uk") return uk_err_division_mismatch(inputs)
	if (locale === "hi") return hi_err_division_mismatch(inputs)
	if (locale === "ar") return ar_err_division_mismatch(inputs)
	if (locale === "ms") return ms_err_division_mismatch(inputs)
	if (locale === "bn") return bn_err_division_mismatch(inputs)
	if (locale === "zh-TW") return zh_tw2_err_division_mismatch(inputs)
	if (locale === "zh-HK") return zh_hk2_err_division_mismatch(inputs)
	if (locale === "ur") return ur_err_division_mismatch(inputs)
	if (locale === "fa") return fa_err_division_mismatch(inputs)
	if (locale === "sw") return sw_err_division_mismatch(inputs)
	if (locale === "nl") return nl_err_division_mismatch(inputs)
	return en_err_division_mismatch(inputs)
});